import React from 'react'
import { DEFAULT_SECTION_NAME } from '../constants'

export const SectionTitleCell = (props) => (
  <td className="section-cell">
    <span>{props.dataItem.section_name !== DEFAULT_SECTION_NAME ? props.dataItem.section_name : ''}</span>
  </td>
)
